// src/mappers/sales/quotation/initializeQuotationMapper.ts

export const initializeQuotationMapper = (
    form: any
) => {

    return {

        customerId:
            form.customer?.id ?? null,

        sellerId:
            form.seller?.id ?? null,

        branchId:
            form.branch?.id ?? null,

        expirationDate:
            form.expirationDate,

        // ==========================
        // 🔹 Condición de pago / crédito
        // ==========================

        paymentConditionId:
            form.paymentCondition?.id ?? null,

        termId:
            form.paymentCondition?.termId ?? null,

        creditDays:
            form.paymentCondition?.creditDays ?? null,

        creditMonths:
            form.paymentCondition?.creditMonths ?? null,

        creditYears:
            form.paymentCondition?.creditYears ?? null,

        creditDueDate:
            form.paymentCondition?.creditDueDate ?? null,

    };

};